import { useDispatch, useSelector } from 'react-redux';
import { getOuGroupData } from 'redux/slices/getOuGroups';

export const useRefreshGroupTab = () => {
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const selectedNode = useSelector((state) => state.selectedNode);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { pageGroupNumber, pageGroupSize, groupSearch, groupIsDescending, groupSortType } = useSelector(
    (state) => state.getOuGroupData
  );

  let uservalue;

  if (role === 'ouadmin') {
    uservalue = {
      ouName: adminOuName && adminOuName.dnName,
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      page: pageGroupNumber,
      pageSize: pageGroupSize,
      searchQuery: groupSearch,
      isDescending: groupIsDescending,
      sortType: groupSortType,
    };
  } else {
    uservalue = {
      ouName:
        selectedNode.selectedNode && selectedNode.selectedNode.dnName
          ? selectedNode.selectedNode.dnName
          : localStorage.getItem('domainDn'),
      fqdn: selectedNode.domainName || localStorage.getItem('domain'),
      page: pageGroupNumber,
      pageSize: pageGroupSize,
      searchQuery: groupSearch,
      isDescending: groupIsDescending,
      sortType: groupSortType,
    };
  }
  const refreshGroupTab = () => {
    dispatch(getOuGroupData(uservalue));
  };

  return refreshGroupTab;
};
